<template>
  <div class="wrapper">
    <notifications></notifications>
    <Sidebar></Sidebar> <!-- Sidebar component is now included here -->

    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
// import Sidebar from './Sidebar.vue'; // Import the Sidebar component
import Sidebar from './Sidebar.vue';
import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import { FadeTransition } from 'vue2-transitions';

export default {
  components: {
    Sidebar, // Register the Sidebar component
    DashboardNavbar,
    ContentFooter,
    FadeTransition
  },
  computed: {
    peranan() {
      const user = JSON.parse(localStorage.getItem('user'));
      return user && user.peranan ? user.peranan : 'User';
    }
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        initScrollbar('sidenav');
      }
    }
  },
  mounted() {
    this.initScrollbar()
  }
};
</script>
